module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_j_leucistic.72565e31.png";